import { Intro, PricePage, Fund, Login, Internal, CreateUser } from ".";
export default {
  path: "",
  childRoutes: [
    { path: "", component: Intro, isIndex: true },
    { path: "login", component: Login, isIndex: true },
    { path: "price", component: PricePage, isIndex: false },
    { path: "fund", component: Fund, isIndex: false },
    { path: "settings", component: Internal, isIndex: false },
    { path: "createUser", component: CreateUser, isIndex: false },
  ],
};
